import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState } from "react";
import axios from "axios";
import "./mentor.css";
import Swal from "sweetalert2";

function Mentor() {
  const [formData, setFormData] = useState({
    mentorName: "",
    mobileNumber: "",
    email: "",
    bankAccountHolderName: "",
    bankAccountNumber: "",
    ifscCode: "",
    panNumber: "",
    aadharCard: "",
    socialMediaDetails: "",
    coupancode: "",
  });

  const [aadharFile, setAadharFile] = useState(null);
  const [chequeFile, setChequeFile] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "panNumber" ? value.toUpperCase() : value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "Aadhar") {
      setAadharFile(files[0]);
    } else if (name === "CancelledCheque") {
      setChequeFile(files[0]);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        data.append(key, value);
      });

      if (aadharFile) data.append("Aadhar", aadharFile);
      if (chequeFile) data.append("CancelledCheque", chequeFile);

      const response = await axios.post(
        `${INVENTORY_API_BASE_URL}/submit-mentor`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Mentor data submitted successfully!",
      }).then(() => {
        window.location.reload();
      });

    } catch (error) {
      console.error("Submission failed:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong while submitting data.",
      });
    }
  };

  return (
    <div className="Mentor-container">
      <form onSubmit={handleSubmit} className="mentor-form">
        <h2>Mentor Registration Form</h2>
        <div>
          <label>Mentor Name</label>
          <input
            name="mentorName"
            placeholder="Mentor Name"
            value={formData.mentorName}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Mobile Number</label>
          <input
            name="mobileNumber"
            type="tel"
            pattern="[0-9]{10}"
            placeholder="Mobile Number"
            value={formData.mobileNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Email</label>
          <input
            name="email"
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Bank Account Holder Name</label>
          <input
            name="bankAccountHolderName"
            placeholder="Bank Account Holder Name"
            value={formData.bankAccountHolderName}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Bank Account Number</label>
          <input
            name="bankAccountNumber"
            placeholder="Bank Account Number"
            value={formData.bankAccountNumber}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>IFSC Code</label>
          <input
            name="ifscCode"
            placeholder="IFSC Code"
            value={formData.ifscCode}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>PAN Number</label>
          <input
            name="panNumber"
            placeholder="PAN Number"
            value={formData.panNumber}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Aadhar Card Number</label>
          <input
            name="aadharCard"
            placeholder="Aadhar Card Number"
            value={formData.aadharCard}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Social Media Handle</label>
          <input
            name="socialMediaDetails"
            placeholder="Social Media Handle"
            value={formData.socialMediaDetails}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Coupon Code</label>
          <input
            name="coupancode"
            placeholder="Coupon Code"
            value={formData.coupancode}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Upload Aadhar Card File</label>
          <input
            type="file"
            name="Aadhar"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={handleFileChange}
            required
          />
        </div>

        <div>
          <label>Upload Cancelled Cheque</label>
          <input
            type="file"
            name="CancelledCheque"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={handleFileChange}
            required
          />
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default Mentor;
